// extracted by mini-css-extract-plugin
export default {"root":"Instructions_root__36bmg","list":"Instructions_list__1hTj8"};